require('./angular/app.js');
require('./angular/controllers/PitchMediaListCtrl');
require('./angular/controllers/PitchDownloadModalCtrl');
require('./angular/services/AuditionHandler');
require('./angular/services/DownloadHandler');
require('./angular/services/MediaFilter');



// WEBPACK FOOTER //
// ./src/MediaClientBundle/Resources/js/index.js